import React, { memo } from 'react';
import $ from 'jquery';
import PropTypes from 'prop-types';
import { isPresent } from 'utils/isPresent';

import AddOrEditCustomerDialog from 'components/Customers/AddOrEditCustomer/AddOrEditCustomerDialog';

import NewCustomerDialogIFrame from './NewCustomerDialogIFrame';

const NewCustomerDialogContainer = ({ open, closeDialog, onSuccess }) => {
  // eslint-disable-next-line no-jquery/no-jquery-constructor,no-jquery/no-data
  const foundation = isPresent($(document.body).data('foundation'));

  return foundation && open ? (
    <NewCustomerDialogIFrame closeDialog={closeDialog} />
  ) : (
    <AddOrEditCustomerDialog open={open} closeDialog={closeDialog} onSuccess={onSuccess} />
  );
};

NewCustomerDialogContainer.propTypes = {
  open: PropTypes.bool,
  onSuccess: PropTypes.func,
  closeDialog: PropTypes.func,
};

export default memo(NewCustomerDialogContainer);
